import React from 'react';
import { useTranslation } from 'react-i18next';

import { ContractReview } from '../../../../models/Entities/Contracts/ContractReview';
import { GuideDrawer, GuideDrawerSection } from '../../../../theme/components/GuideDrawer';
import { formatDateTime } from '../ContractReview.Functions';
import { useCodeText } from '../ContractReview.Text';

// Metadatos de la revisión (quién, cuándo, modelo, alcances, extracción, instrucciones): fuera del camino, en un panel lateral.

export interface ContractReviewDetailsDrawerProps {
  open: boolean;
  review: ContractReview;
  addendumName?: string;
  onDismiss: () => void;
}

export const ContractReviewDetailsDrawer: React.FC<ContractReviewDetailsDrawerProps> = ({ open, review, addendumName, onDismiss }) => {
  const { t } = useTranslation();
  const codeText = useCodeText();
  const row = (label: string, value: React.ReactNode, testId?: string) => (
    <>
      <dt>{label}</dt>
      <dd data-testid={testId}>{value}</dd>
    </>
  );

  return (
    <GuideDrawer open={open} onDismiss={onDismiss} size="small" title={t('contractReview.overview.details')} subtitle={t('contractReview.page.title')} testId="review-details">
      <GuideDrawerSection>
        <dl className="crv-details">
          {row(t('contractReview.page.addendum'), addendumName ?? t('contractReview.history.wholeContract'))}
          {row(t('contractReview.history.columns.mode'), codeText('mode', review.mode))}
          {row(t('contractReview.history.columns.trigger'), codeText('trigger', review.trigger))}
          {row(t('contractReview.launcher.scopes'), review.scopes.map(scope => codeText('scope', scope)).join(', '))}
          {row(t('contractReview.page.files'), review.fileIds.length)}
          {row(t('contractReview.page.createdBy'), review.createdBy)}
          {row(t('contractReview.page.created'), formatDateTime(review.created))}
          {review.endTimestamp && row(t('contractReview.page.ended'), formatDateTime(review.endTimestamp))}
          {review.model && row(t('contractReview.page.model'), review.model)}
          {review.extractionSummary &&
            row(
              t('contractReview.overview.step1'),
              t('contractReview.page.extraction', {
                stages: review.extractionSummary.stages,
                concepts: review.extractionSummary.concepts,
                branches: review.extractionSummary.branches,
                cycles: review.extractionSummary.cycles
              }),
              'review-extraction'
            )}
          {review.instructions && row(t('contractReview.overview.instructions'), <q>{review.instructions}</q>)}
          {review.appliedAt && row(t('contractReview.overview.applied', { user: review.appliedBy ?? '—', date: formatDateTime(review.appliedAt) }), '')}
        </dl>
      </GuideDrawerSection>
    </GuideDrawer>
  );
};

export default ContractReviewDetailsDrawer;
